import { useState } from "react";
import { Button, Col, Form, Input, Row, Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";

import QuestionContent from "./QuestionContent";

export default function RenderSubQuestion(props) {
	const {
		namePath = [],
		form_question_options = [],
		required = false,
		question = null,
		description = null,
		add_another = false,
	} = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	// Track the number of input sets
	const [inputs, setInputs] = useState(add_another ? [{ id: 0 }] : []);

	// Add another input set
	const handleAddAnother = () => {
		setInputs((prev) => [...prev, { id: prev.length }]);
	};

	// If add_another is enabled, render for each input set
	if (add_another) {
		return (
			<>
				{inputs.map((input, idx) => (
					<Col
						xs={24}
						sm={24}
						md={24}
						lg={24}
						xl={24}
						key={`input_set_${input.id}`}
					>
						<Row>
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<div
									className="quill-output question"
									dangerouslySetInnerHTML={{
										__html: question,
									}}
								/>
								{description && (
									<div className="description">{description}</div>
								)}
							</Col>
						</Row>
						{form_question_options.map((form_question_option) => (
							<Row
								key={`${newNamePath}_${form_question_option.id}_${input.id}`}
							>
								<RenderSubQuestionMemo
									namePath={`${newNamePath}_set_${idx}`}
									form_question_option={form_question_option}
									required={required}
									add_another={add_another}
								/>
							</Row>
						))}
					</Col>
				))}

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Button
						type="link"
						className="w-auto h-auto p-0"
						icon={<FontAwesomeIcon icon={faPlus} />}
						onClick={handleAddAnother}
					>
						Add Another
					</Button>
				</Col>
			</>
		);
	}

	// If add_another is not enabled, render normally
	return (
		<>
			{form_question_options.map((form_question_option) => (
				<Row key={`${newNamePath}_${form_question_option.id}`}>
					<Col xs={24} sm={24} md={24} lg={24} xl={24}>
						<div
							className="quill-output question"
							dangerouslySetInnerHTML={{
								__html: question,
							}}
						/>
						{description && <div className="description">{description}</div>}
					</Col>

					<RenderSubQuestionMemo
						namePath={newNamePath}
						form_question_option={form_question_option}
						required={required}
						add_another={add_another}
					/>
				</Row>
			))}
		</>
	);
}

const RenderSubQuestionMemo = (props) => {
	const {
		namePath = [],
		form_question_option,
		required = false,
		// add_another = false,
	} = props;

	const [optionRequired, setOptionRequired] = useState(
		form_question_option.option_required ? false : true,
	);

	return (
		<>
			<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
				<Typography.Text strong>{form_question_option.option}</Typography.Text>
			</Col>
			{form_question_option.option_required ? (
				<Col xs={24} sm={24} lg={24} xl={24} xxl={24} className="mb-10 ml-20">
					<Form.Item name={namePath}>
						<Input
							type="text"
							placeholder="Answer"
							onBlur={(e) => {
								if (e.target.value) {
									setOptionRequired(true);
								} else {
									setOptionRequired(false);
								}
							}}
						/>
					</Form.Item>
				</Col>
			) : null}

			{optionRequired && (
				<Col xs={24} sm={24} lg={24} xl={24} xxl={24}>
					<QuestionContent
						namePath={`${namePath}_qo_${form_question_option.id}`}
						question={form_question_option.question_option}
						type={form_question_option.sub_option_type}
						required={required}
						max_checkbox={form_question_option.max_checkbox}
						escape_questions={form_question_option.escape_questions}
						form_question_options={form_question_option.form_question_options}
					/>
				</Col>
			)}
		</>
	);
};
